// removed by extract-text-webpack-plugin
module.exports = {"container":"StaffContactNumbers__container___2hAFw"};